import { toteValidate } from "../../application/dtos/tote_validate";

export class toteLabelEntity {
    constructor({id, label}){
        this.id = id;
        this.label = label;
    }

    isValid() {
        return toteValidate(this);
    }
}